import { IconWebhookOutline18 as Webhook } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { McpIcon } from "@productlane/ui/src/icons/project/mcp-icon"

import { ConnectorLogo } from "@/components/connector-logo"
import { vendorPresetForUrl } from "./presets"

// A vendor we know shows its own mark; anything else shows the stored logo or
// the server's favicon.
export function ConnectorLogoTile({
	url,
	logoUrl,
	type,
	size = "md",
}: {
	url: string
	logoUrl: string | null
	type: "HTTP" | "MCP"
	size?: "md" | "lg"
}) {
	const preset = vendorPresetForUrl(url)
	const box = cn(
		size === "lg" ? "h-10 w-10" : "h-8 w-8",
		preset?.logoFillsTile
			? "overflow-hidden p-0"
			: size === "lg"
				? "p-2"
				: "p-1.5",
	)
	return (
		<span
			className={cn(
				"flex flex-none items-center justify-center rounded-md bg-white text-primary ring-1 ring-black/5 dark:bg-gray-800 dark:ring-white/10",
				box,
			)}
		>
			{preset ? (
				<preset.Logo className="h-full w-full flex-none" />
			) : (
				<ConnectorLogo
					url={url}
					logoUrl={logoUrl}
					FallbackIcon={type === "MCP" ? McpIcon : Webhook}
					sizeClassName="h-full w-full"
					iconClassName="h-[18px] w-[18px]"
				/>
			)}
		</span>
	)
}
